import React, { useEffect } from 'react';
import { WhisperSpinner as Spinner } from 'react-spinners-kit';
import style from './whisper-spinner.module.scss';

/* eslint-disable-next-line */
export interface WhisperSpinnerProps {
    isLoading: boolean;
    message?: string;
}

export function WhisperSpinner(props: WhisperSpinnerProps) {
    return (
        <div className={`${style.container} ${props.isLoading ? style.active : ''}`}>
            <div className={style.spinner}>
                <Spinner size={80} frontColor='#004763' backColor='#015473' />
                <div className={`${style.message} ${props.message ? style.active : ''}`}>
                    {props.message}
                </div>
            </div>
        </div>
    );
}

export default WhisperSpinner;
